// extracted by mini-css-extract-plugin
module.exports = {"city__stub":"city__stub-2wXqw","manage":"manage-7g3Q5","download":"download-3Wokj"};